module.exports = __webpack_public_path__ + "static/media/integral_card_2.55af935d.png";